import { createFileRoute } from "@tanstack/react-router";
import { DocPage } from "@/components/DocPage";

export const Route = createFileRoute("/fees")({
  head: () => ({
    meta: [
      { title: "Fees — Want To Buy" },
      { name: "description", content: "Want To Buy is free to use — no platform fee, no listing fees, no monthly minimums." },
      { property: "og:title", content: "Fees — Want To Buy" },
      { property: "og:description", content: "Want To Buy is free to use — no platform fee, no listing fees, no monthly minimums." },
      { name: "twitter:title", content: "Fees — Want To Buy" },
      { name: "twitter:description", content: "Want To Buy is free to use — no platform fee, no listing fees, no monthly minimums." },
    ],
  }),
  component: FeesPage,
});

export function FeesContent() {
  return (
    <>
      <section className="panel-note">
        <h2 className="!mt-0">Want To Buy is free to use</h2>
        <p>
          There is currently <strong>no platform fee</strong> on transactions. Buyers and sellers keep 100% of what they agree on — the buyer pays the price + shipping, and the seller receives the full amount.
        </p>
        <ul>
          <li>No fee to post a buy order.</li>
          <li>No fee to submit an offer.</li>
          <li>No fee on completed transactions.</li>
          <li>No subscription, no monthly minimum, no listing fees.</li>
        </ul>
      </section>

      <section>
        <h2>What we don't provide</h2>
        <p>
          Because there is no platform fee, Want To Buy also does not provide any platform-backed guarantee, insurance, or dispute-mediation service. Buyer and seller protection comes entirely from your payment provider (PayPal Goods &amp; Services is strongly recommended). See the <a href="/payment-safety">Payment Safety page</a> for details.
        </p>
      </section>

      <section>
        <h2>Future changes</h2>
        <p>
          If a platform fee is ever introduced, we will notify all users at least 30 days in advance via email and on-platform notification. Transactions in progress at that time will be honoured under the current free terms.
        </p>
      </section>
    </>
  );
}

function FeesPage() {
  return (
    <DocPage eyebrow="Pricing" title="Fees" intro="Want To Buy is currently free to use — no platform fee on transactions, no listing fees, no hidden charges.">
      <FeesContent />
    </DocPage>
  );
}
